import { render, staticRenderFns } from "./MonitoringErrorsServer.vue?vue&type=template&id=aaab53e2&scoped=true&lang=pug"
import script from "./MonitoringErrorsServer.vue?vue&type=script&lang=js"
export * from "./MonitoringErrorsServer.vue?vue&type=script&lang=js"
import style0 from "./MonitoringErrorsServer.vue?vue&type=style&index=0&id=aaab53e2&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaab53e2",
  null
  
)

export default component.exports